// synthetic source map